import { buildMap } from '@components/ArtBoard/Threads/utils'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useSelector } from 'react-redux'

import type { Recipient } from '@/types'

export const useUsersMap = () => {
  const recipients = useSelector(
    migrationProjectSelector.getProjectRecipients
  ) as Recipient[]

  return buildMap(recipients)
}
